import { render, staticRenderFns } from "./MonitoramentoDashboard.vue?vue&type=template&id=1f9b71e4&scoped=true&lang=pug"
import script from "./MonitoramentoDashboard.vue?vue&type=script&lang=js"
export * from "./MonitoramentoDashboard.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoDashboard.vue?vue&type=style&index=0&id=1f9b71e4&prod&lang=scss&scoped=true"
import style1 from "./MonitoramentoDashboard.vue?vue&type=style&index=1&id=1f9b71e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b71e4",
  null
  
)

export default component.exports